<template>
    <div class="workshop" :class="isThemeAja ? 'aja-bg-main' : ''">
        <v-card elevation="4" :color="isThemeAja ? color : 'primary'" dark>
            <v-card-text>
                <v-row align="center" class="headline" no-gutters>
                    <v-col class="font-weight-bold white--text">{{ value.name }}</v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-row v-if="isThePro">
            <v-col cols="12">
                <v-card elevation="4" class="mt-2" :color="isThemeAja ? '#1E3945' : ''" >
                    <v-card-text class="subtitle-1">
                        <v-row justify="space-around">
                            <v-col cols="auto">
                                Atelier <b>{{ value.type_name }}</b>
                            </v-col>
                            <v-col cols="auto">
                                Atelier <b v-if="value.active">visible</b><b v-else>désactivé</b>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="value.description">
            <v-col cols="12">
                <v-card :color="isThemeAja ? '#1E3945' : ''" elevation="4">
                    <v-card-text class="subtitle-1">
                        {{ value.description }}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row justify="space-around" align="stretch">
            <v-col cols="12" :md="6">
                <WorkshopCard style="height: 220px; width: auto" ref="WorkshopCard" v-model="value" :type="value.type" :options="{hideTitle: true}" :color="color" class="fill-height"/>
            </v-col>

            <v-col cols="12" :md="6" v-if="logo_path">
                <v-img :style="{backgroundColor: isThemeAja ? '#1E3945' : ($vuetify.theme.dark ? '#1E1E1E' : 'white')}" :src="logo_path" width="auto" contain height="220px"  class="mt-3"></v-img>
            </v-col>

        </v-row>

        <v-row>
            <v-col cols="12" class="mb-5">
                <v-card :color="isThemeAja ? '#1E3945' : ''" elevation="4">
                    <v-card-title class="justify-center">{{ meetingsTitle }}</v-card-title>
                    <v-card-text>
                        <v-row class="mx-n4">
                            <v-col v-if="!isThePro" cols="12" class="mx-0 body-1 font-weight-bold white--text">
                                Le n° de la séquence n'a pas d'importance, vous pouvez commencer n'importe quand.
                            </v-col>
                            <v-col cols="12">
                                <v-data-table 
                                    :style="{backgroundColor: isThemeAja ? '#1E3945' : color}" 
                                    :items="loadedMeetings"
                                    :items-per-page="-1"
                                    item-key="id"
                                    :headers="meetingsHeader"
                                    :options.sync="options"
                                    :show-expand="isThePro"
                                    :item-class="(item, isExpanded) => {return {'grey--text': $moment().diff(item.start) > 0}}"
                                    :loading="meetingsLoading"
                                    loading-text="Chargement..."
                                    :footer-props="$acl.check('isAuth') ? { 'items-per-page-options': [20, 30, 40, -1] } : {}"
                                    :server-items-length="total != 0 ? total : loadedMeetings.length"
                                    :hide-default-footer="!$acl.check('isAuth')"
                                    class="mt-4"
                                >
                                    <template v-slot:item.start="{ item }">
                                        {{ $moment(item.start).format('dddd DD/MM/YYYY') }}
                                    </template>

                                    <template v-slot:item.type="{ item }">
                                        <v-btn depressed dark v-if="item.type == 'remote'" :color="isThemeAja ? '#294D5B' : ''"  class="px-11" style="border-radius: 0px; pointer-events: none;">
                                            VISIO
                                        </v-btn>
                                        <v-btn depressed :color="isThemeAja ? '#1E3945' : '#D3D3D3'" :class="isThemeAja ? 'white--text' : ''" v-if="item.type == 'onsite'" style="color: black; border-radius: 0px; pointer-events: none;">
                                            PRESENTIEL
                                        </v-btn>
                                    </template>

                                    <template v-slot:item.timeslot="{ item }">
                                        <span class="d-flex justify-center">{{ $moment(item.start).format('HH[h]mm') }} - {{ $moment(item.end).format('HH[h]mm') }}</span>
                                    </template>

                                    <template v-slot:item.places_diff="{ item }">
                                        {{ item.places - item.validated_subscribers_count }} <small>/ {{ item.places }}</small>
                                    </template>

                                    <template v-slot:item.downloads="{ item }">
                                        <template v-if="$moment().diff(item.end, 'm') <= 15">
                                            <template v-if="isThePro">
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on: tooltipOn }">
                                                                <v-btn
                                                                    v-on="{ ...on, ...tooltipOn }"
                                                                    v-bind="attrs"
                                                                    fab
                                                                    outlined
                                                                    :color="isThemeAja ? '#4E983C' : 'primary'"
                                                                    small
                                                                    class="mx-5"
                                                                    depressed
                                                                    :disabled="!canAccessSupport(item)"
                                                                >
                                                                    <v-icon>get_app</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <span>
                                                                Accéder aux supports de la séance
                                                            </span>
                                                        </v-tooltip>
                                                    </template>
                                                    <v-list>
                                                        <v-list-item
                                                            @click="canAccessSupportByType(item, 'user') && getSupport('user', item.sequence, item.id)"
                                                            :disabled="!canAccessSupportByType(item, 'user')"
                                                            :class="{'v-list-item--disabled': !canAccessSupportByType(item, 'user')}"
                                                        >
                                                            <v-list-item-title :class="{'grey--text': !canAccessSupportByType(item, 'user')}">
                                                                Télécharger le livret d'activités de la séance
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item
                                                            @click="canAccessSupportByType(item, 'guide') && getSupport('guide', item.sequence, item.id)"
                                                            :disabled="!canAccessSupportByType(item, 'guide')"
                                                            :class="{'v-list-item--disabled': !canAccessSupportByType(item, 'guide')}"
                                                        >
                                                            <v-list-item-title :class="{'grey--text': !canAccessSupportByType(item, 'guide')}">
                                                                Ouvrir le guide de la séance
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item
                                                            @click="canAccessSupportByType(item, 'pro') && getSupport('pro', item.sequence, item.id)"
                                                            :disabled="!canAccessSupportByType(item, 'pro')"
                                                            :class="{'v-list-item--disabled': !canAccessSupportByType(item, 'pro')}"
                                                        >
                                                            <v-list-item-title :class="{'grey--text': !canAccessSupportByType(item, 'pro')}">
                                                                Ouvrir le diapo de la séquence
                                                                <span v-if="!canAccessSupportByType(item, 'pro') && canAccessSupportByType(item, 'guide')" class="caption ml-2">
                                                                    (disponible 15 min avant)
                                                                </span>
                                                            </v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item v-if="item.type == 'remote' && item.link">
                                                            <v-list-item-title v-html="urlify(item.link)"></v-list-item-title>
                                                        </v-list-item>
                                                         <v-list-item v-if="item.type == 'onsite' && item.address">
                                                            <v-list-item-title>{{item.address}}</v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </template>
                                            <template v-if="$acl.check('isUserPremium')">
                                                <v-menu offset-y v-if="isValidatedSubscriber(item)">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            v-on="on"
                                                            outlined
                                                            :color="isThemeAja ? '#4E983C' : 'primary'"
                                                            small
                                                            class="mx-5"
                                                            depressed
                                                        >
                                                            <v-icon>get_app</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <v-list>
                                                        <v-list-item @click="getSupport('user', item.sequence)">
                                                            <v-list-item-title>Télécharger le livret d'activités de la séance</v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item v-if="item.type == 'remote' && item.link">
                                                            <v-list-item-title v-html="urlify(item.link)"></v-list-item-title>
                                                        </v-list-item>
                                                        <v-list-item v-if="item.type == 'onsite' && item.address">
                                                            <v-list-item-title>{{ item.address }}</v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </template>
                                        </template>
                                    </template>
                                    
                                    <template v-slot:item.actions="{ item }">
                                        <!-- PRO BUTTONS -->
                                        <template v-if="isThePro">
                                            <span class="d-flex flex-row">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-on="on"
                                                            fab
                                                            :color="isThemeAja ? '#4E983C' : 'primary'"
                                                            @click.stop="editMeeting(item)"
                                                            small
                                                            depressed
                                                            class="mr-2"
                                                        >
                                                            <v-icon>edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Modifier la séance</span>
                                                </v-tooltip>
                                                
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-on="on"
                                                            fab
                                                            :color="isThemeAja ? '#4E983C' : 'primary'"
                                                            @click.stop="exportMeetingSubscribers(item)"
                                                            small
                                                            depressed
                                                            :loading="loadingStates[item.id] && loadingStates[item.id].export"
                                                        >
                                                            <v-icon>ios_share</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Extraire les données des participants</span>
                                                </v-tooltip>

                                                <v-tooltip bottom v-if="hasActiveMailbox && validatedSubscriberIds(item).length > 0">
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-on="on"
                                                            fab
                                                            :color="isThemeAja ? '#4E983C' : 'primary'"
                                                            @click.stop="messageAllSubscribers(item)"
                                                            small
                                                            depressed
                                                            class="ml-2"
                                                        >
                                                            <v-icon>mail</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Envoyer un message à tous les participants</span>
                                                </v-tooltip>
                                            </span>
                                        </template>
                                        <!-- subscribable only if isn't passed -->
                                        <template v-if="$moment().diff(item.end) < 0">
                                            <!-- USER BUTTONS (also used by ADH PRO on PRO workshops they don't animate) -->
                                            <template v-if="$acl.check('isUserPremium') || ($acl.check('isProPremium') && value.is_pro && !isThePro)">
                                                <v-tooltip bottom v-if="!isValidatedSubscriber(item) && (item.places - item.validated_subscribers_count) > 0 && !isWaitingSubscriber(item)">
                                                    <template v-slot:activator="{ on }">
                                                        <ConfirmButton
                                                            :on="on"
                                                            buttonText="Participer"
                                                            headline="Merci de confirmer votre participation"
                                                            :subtext="getParticipateSubtext(item)"
                                                            :dialog-width="isMeetingWithin48Hours(item) ? 650 : 500"
                                                            :color="isThemeAja ? '#4E983C' : color"
                                                            small
                                                            :loading="loadingStates[item.id] && loadingStates[item.id].subscribe"
                                                            @confirmed="subscribeMeeting(item.id)"
                                                        />
                                                    </template>
                                                    <span>Cliquer pour participer à cette séance </span>
                                                </v-tooltip>
                                                <v-tooltip bottom v-if="!isValidatedSubscriber(item) && !isWaitingSubscriber(item) && (item.places - item.validated_subscribers_count) <= 0">
                                                    <template v-slot:activator="{ on }">
                                                        <ConfirmButton 
                                                            :on="on"
                                                            buttonText="Accès liste d'attente"
                                                            headline="Vous recevrez une alerte mail lorsqu'une place se libérera sur cette séance"
                                                            color="secondary"
                                                            small
                                                            :loading="loadingStates[item.id] && loadingStates[item.id].subscribe"
                                                            @confirmed="subscribeMeeting(item.id)"
                                                        />
                                                    </template>
                                                    <span>Cliquer pour vous abonner</span>
                                                </v-tooltip>
                                                <v-tooltip bottom v-if="isValidatedSubscriber(item)">
                                                    <template v-slot:activator="{ on }">
                                                        <ConfirmButton
                                                            :on="on"
                                                            buttonText="Annuler participation"
                                                            headline="Vous êtes sur le point d'annuler votre participation à cette séance"
                                                            :subtext="getUnsubscribeWarning(item)"
                                                            :confirm-text="showLateUnsubscribeWarning(item) ? 'Se désinscrire quand même' : 'Confirmer'"
                                                            :dialog-width="showLateUnsubscribeWarning(item) ? 650 : 500"
                                                            color="red"
                                                            small
                                                            :loading="loadingStates[item.id] && loadingStates[item.id].unsubscribe"
                                                            @confirmed="unsubscribeMeeting(item.id)"
                                                            class="mx-5"
                                                        />
                                                    </template>
                                                    <span>Cliquer pour annuler votre participation</span>
                                                </v-tooltip>
                                                <WaitlistButton 
                                                    v-if="isWaitingSubscriber(item)"
                                                    :meeting="item"
                                                    :loading="loadingStates[item.id] && loadingStates[item.id].unsubscribe"
                                                    button-text="Sortir de liste d'attente"
                                                    :is-theme-aja="isThemeAja"
                                                    :is-dark-theme="$vuetify.theme.dark"
                                                    @unsubscribe="unsubscribeMeeting"
                                                    @take-place="handleTakePlace"
                                                />
                                            </template>
                                            <!-- PUBLIC BUTTONS -->
                                            <template v-if="$acl.check('isNotAuth') || ($acl.not.check('isUserPremium') && $acl.not.check('isProPremium'))">
                                                <v-tooltip bottom v-if="!isValidatedSubscriber(item) && (item.places - item.validated_subscribers_count) > 0">
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            :color="isThemeAja ? '#4E983C' : color" 
                                                            v-on="on"
                                                            @click.stop="dialogNotConnected = true"
                                                            dark
                                                            small
                                                            class="mx-1"
                                                        >
                                                            Participer
                                                        </v-btn>
                                                    </template>
                                                    <span>Cliquez pour participer à cette séance</span>
                                                </v-tooltip>
                                            </template>
                                        </template>
                                    </template>

                                    <template v-slot:expanded-item="{ headers, item }" v-if="isThePro">
                                        <td :colspan="headers.length" :class="isThemeAja ? 'aja-expanded-row' : ''" :style="isThemeAja ? {backgroundColor: '#1E3945', color: 'white'} : {backgroundColor: $vuetify.theme.dark ? '#1E1E1E' : '#f5f5f5', color: $vuetify.theme.dark ? 'white' : 'black'}">
                                            <div class="pa-3">
                                                <div :class="isThemeAja ? 'participants-header-aja' : 'participants-header'" class="pa-2" :style="isThemeAja ? {backgroundColor: '#4E983C', color: 'white', borderRadius: '4px 4px 0 0'} : {backgroundColor: 'var(--v-primary-base)', color: 'white', borderRadius: '4px 4px 0 0'}">
                                                    <v-icon :color="'white'" class="mr-2">people</v-icon>
                                                    <strong>Liste des participants ({{ (item.subscribers || []).length }})</strong>
                                                </div>
                                                <v-data-table 
                                                    :style="isThemeAja ? {backgroundColor: '#294D5B', borderRadius: '0 0 4px 4px'} : {backgroundColor: $vuetify.theme.dark ? '#2D2D2D' : 'white', borderRadius: '0 0 4px 4px'}"
                                                        :class="{'theme-aja-active': isThemeAja, 'elevation-2': true}"
                                                        :items="item.subscribers || []"
                                                        :items-per-page="-1"
                                                        item-key="id"
                                                        :headers="[
                                                            {
                                                                text: 'Nom',
                                                                align: 'left',
                                                                value: 'complete_name',
                                                            },
                                                            {
                                                                text: 'Email',
                                                                align: 'left',
                                                                value: 'email',
                                                            },
                                                            {
                                                                text: 'Téléphone',
                                                                align: 'left',
                                                                value: 'phone',
                                                            },
                                                            {
                                                                text: 'Statut',
                                                                align: 'center',
                                                                value: 'pivot.status',
                                                            },
                                                            {
                                                                text: 'Présent',
                                                                align: 'center',
                                                                value: 'pivot.attendance',
                                                                sortable: false,
                                                            },
                                                        ]"
                                                        hide-default-footer
                                                        :options="{
                                                            sortBy: ['pivot.status'],
                                                            sortDesc: [false],
                                                        }"
                                                        dense
                                                    >
                                                        <template v-slot:item.complete_name="{ item }">
                                                            <span @click="$router.push({name: 'ProUser', params: {id: item.id}})">
                                                                {{ item.complete_name }}
                                                            </span>
                                                        </template>

                                                        <template v-slot:item.pivot.status="{ item }">
                                                            <template v-if="item.pivot.status == 'validated'">
                                                                Inscrit
                                                            </template>
                                                            <template v-else>
                                                                En attente
                                                            </template>
                                                        </template>

                                                        <template v-slot:item.pivot.attendance="{ item }">
                                                            <v-edit-dialog 
                                                                :ref="'attendanceForm'+item.pivot.id" 
                                                                v-if="$moment().diff(loadedMeetings.find(m => m.id == item.pivot.meeting_id).start) >= 0"
                                                            >
                                                                <div>
                                                                    <v-icon small v-if="item.pivot.attendance">done</v-icon>
                                                                    <v-icon small v-else-if="item.pivot.attendance != null">close</v-icon>
                                                                    <span v-else>-</span>
                                                                </div>
                                                                <template v-slot:input>
                                                                    <v-radio-group 
                                                                        v-model="item.pivot.attendance" 
                                                                        row
                                                                        hide-details
                                                                        class="my-3"
                                                                        @change="saveAttendance(item.pivot)"
                                                                        :loading="attendanceLoading"
                                                                        :disabled="attendanceLoading"
                                                                    >
                                                                        <v-radio
                                                                            label="Oui"
                                                                            :value="1"
                                                                            :ripple="false"
                                                                        ></v-radio>
                                                                        <v-radio
                                                                            label="Non"
                                                                            :value="0"
                                                                            :ripple="false"
                                                                        ></v-radio>
                                                                    </v-radio-group>
                                                                </template>
                                                            </v-edit-dialog>
                                                        </template>
                                                    </v-data-table>
                                            </div>
                                        </td>
                                    </template>

                                    <template v-slot:no-data>
                                        Aucune {{ meetingsTitle.toLowerCase() }}
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                        <v-tooltip bottom v-if="isThePro">
                            <template v-slot:activator="{ on }">
                                <v-btn 
                                    v-on="on"
                                    :color="isThemeAja ? '#4E983C' : 'primary'"
                                    absolute 
                                    top 
                                    fab
                                    right 
                                    @click="editMeeting({subscribers: []})"
                                    class="mt-12"
                                    :dark="!!isThemeAja"
                                >
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </template>
                            <span>Ajouter une séance</span>
                        </v-tooltip>
                    </v-card-text>
                </v-card>
                <v-dialog
                    v-model="dialogNotConnected"
                    width="500"
                >
                    <v-card :color="isThemeAja ? '#1E3945' : ''" :style="{'border': '1em solid white'}">
                        <v-card-text :class="{'headline py-5 px-5': true, 'white--text': $vuetify.theme.dark, 'black--text': !$vuetify.theme.dark}">
                            <template v-if="$acl.check('isNotAuth')">
                                Nous vous invitons à créer votre compte ou vous connecter si vous avez déjà un compte
                            </template>
                            <template v-else>
                                Vous avez bien créé votre compte mais vous n'êtes pas encore adhérent
                            </template>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-btn
                                color="secondary"
                                @click="dialogNotConnected = false"
                                class="mx-2 my-2"
                            >
                                Annuler
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                v-if="$acl.check('isNotAuth')"
                                :color="isThemeAja ? '#4E983C' : 'primary'"
                                dark
                                @click="$router.push({name: 'register'})"
                                class="mx-2 my-2"
                            >
                                Créer un compte
                            </v-btn>
                            <v-btn
                                v-if="$acl.check('isNotAuth')"
                                :color="isThemeAja ? '#4E983C' : 'primary'"
                                dark
                                @click="$router.push({name: 'login'})"
                                class="mx-2 my-2"
                            >
                                Se connecter
                            </v-btn>
                            <v-btn
                                v-else
                                :color="isThemeAja ? '#4E983C' : 'primary'"
                                dark
                                @click="$router.push({name: 'register'})"
                                class="mx-2 my-2"
                            >
                                Adhérer
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialogAddMeeting" max-width="900px" persistent scrollable>
                    <v-card :color="isThemeAja ? '#1E3945' : ''">
                        <v-card-title :style="isThemeAja ? 'background-color: #4E983C!important' : ''" class="secondary white--text">
                            Ajout d'une séance
                        </v-card-title>
                        <v-card-text>
                            <MeetingForm ref="MeetingForm" v-model="editedMeeting" :workshop="value" :key="Date.now()" @savedForm="handleSavedMeetingForm" @canceledForm="handleCanceledMeetingForm"/>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>

    </div>
</template>
<script>
import JSZip from 'jszip'
import MeetingForm from '@/components/meetings/Form'
import WorkshopCard from '@/components/workshops/Card'
import WaitlistButton from '@/components/meetings/WaitlistButton.vue'
import { mapGetters } from 'vuex'
import { generateAccessControlScript, parisDateToIso, ACCESS_TIMER_MINUTES, ONCOMMENCE_ACCESS_TIMER_MINUTES } from '@/utils/iSpringAccessControl'

export default{
    components: {
        MeetingForm,
        WorkshopCard,
        WaitlistButton
    },
    props: {
        value: {
            type: Object,
            required: true
        },
        color: {
            type: String,
            default: 'primary'
        }
    },
    data(){
        return {
            meetingsHeader: [
                {
                    text: 'Date',
                    align: 'center',
                    value: 'start',
                    width: '150px',
                },
                {
                    text: 'Type',
                    align: 'center',
                    value: 'type',
                    sortable: false,
                },
                {
                    text: 'Horaires',
                    align: 'center',
                    value: 'timeslot',
                    sortable: false,
                    width: '150px',
                },
                {
                    text: 'Nombre de places restantes',
                    align: 'center',
                    value: 'places_diff',
                    sortable: false,
                },
                {
                    text: 'Séquence',
                    value: 'sequence', 
                    align: 'center', 
                    sortable: false
                },
                {
                    text: '',
                    value: 'downloads',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                },
            ],
            dialogAddMeeting: false,
            editedMeeting: {},
            dialogNotConnected: false,
            selectedMeeting: null,
            marker: null,
            logo_path: null,
            apiUrl: process.env.VUE_APP_API_URL,
            attendanceLoading: false,
            meetingsLoading: false,
            options: {
                page: parseInt(this.$route.query.page) || 1,
                itemsPerPage: this.$route.query.per_page ? parseInt(this.$route.query.per_page) : 20,
                sortBy: this.$route.query.sort ? [this.$route.query.sort] : ['start'],
                sortDesc: this.$route.query.direction ? this.$route.query.direction == 'desc' : [false],
            },
            total: 0,
            userSubscribitions: [],
            loadingStates: {},
        }
    },
    computed: {
        ...mapGetters(['isThemeAja']),
        meetingsTitle() {
            return 'Séances' + (this.isThePro ? '' : ' à venir')
        },
        loadedMeetings() {
            if (this.meetingsLoading)
                return []
            let filteredMeetings = this.value.meetings.filter((m) => {
                // filter (remove passed meeting in user workshop vue)
                return ! (this.$moment().diff(m.start) > 0 && ! this.isThePro)
            })
            
            // Sort the filtered meetings based on options
            return filteredMeetings.sort((a, b) => {
                const dateA = new Date(a.start);
                const dateB = new Date(b.start);
                return this.options.sortDesc[0] ? dateB - dateA : dateA - dateB;
            });
        },
        isThePro() {
            return this.$acl.check('isProPremium') &&
                (this.value.user_id == this.$store.getters.getProfile.id ||
                 this.value.secondary_pro_id == this.$store.getters.getProfile.id ||
                    (this.value.next_substitutions && this.value.next_substitutions.some(
                        obj => obj.user_id ===  this.$store.getters.getProfile.id &&
                        this.$moment(obj.start) <= this.$moment() && 
                        this.$moment(obj.end) >= this.$moment())
                    )
                );
        },
        hasActiveMailbox() {
            const alias = this.$store.getters.getProfile?.mailbox_alias
            return !!(alias && alias.validated_at && !alias.is_blocked && !alias.deleted_at)
        },
    },
    watch: {
        options: {
            handler () {
                if (this.isThePro) {
                    this.fetchMeetingsSubscribers()
                }
            },
            deep: true,
        },
        isThePro: {
            immediate: true,  // This ensures the watcher runs immediately when the component is created
            handler(newValue) {
                this.options.sortDesc = [newValue]
            }
        }
    },
    async mounted() {
        // Rafraîchir le profil utilisateur pour avoir les données à jour
        try {
            await this.$store.dispatch('profileRequest');
        } catch (error) {
            console.warn('Impossible de rafraîchir le profil:', error);
        }
        
        if (this.$store.getters.getProfile.id && !this.isThePro) {
            this.getUserSubscribitions()
        }

        if (this.value.partner && this.value.partner.logo_id)
            this.fetchPartnerLogo()

        if (this.isThePro) {
            this.fetchMeetingsSubscribers()
            this.meetingsHeader.push({text: 'Participants', value: 'data-table-expand', align: 'center', sortable: false})
        }
    },
    methods: {
        deleteToApi() {
            return this.$store.dispatch('workshopDeleteRequest', { id: this.value.id}).then(() => {
                this.$store.commit('setSnack', {'type': 'success', 'msg': 'Atelier supprimé !'});
                this.$router.push({name: 'ProWorkshops'})
            }).catch((err) => {
                if (err.response.status != 403)
                    this.$store.dispatch('setErrors', err.response.data)
            });
        },
        editMeeting(meeting) {
            this.editedMeeting = Object.assign({}, meeting)
            this.editedMeeting.subscribers = this.filterSubscribers(meeting.subscribers, 'validated')
            this.editedMeeting.queued = this.filterSubscribers(meeting.subscribers, 'waiting')
            this.dialogAddMeeting = true
        },
        handleCanceledMeetingForm() {
            this.editedMeeting = {}
            this.dialogAddMeeting = false
        },
        handleSavedMeetingForm(meeting) {
            this.dialogAddMeeting = false
            let i = this.value.meetings.findIndex(m => m.id == meeting.id)
            if (i >= 0)
                Object.assign(this.value.meetings[i], meeting)
            else
                this.value.meetings.push(meeting)
        },
        async subscribeMeeting(meeting_id) {
            // Initialize loading state for this meeting if it doesn't exist
            if (!this.loadingStates[meeting_id]) {
                this.$set(this.loadingStates, meeting_id, {})
            }
            // Set subscribe loading state for this specific meeting
            this.$set(this.loadingStates[meeting_id], 'subscribe', true)

            try {
                const response = await this.$store.dispatch('meetingSubscribeRequest', {
                    meeting_id: meeting_id,
                    user_id: this.$store.getters.getProfile.id
                })
                
                if (response.status === 202) {
                    this.$store.commit('setSnack', {
                        'type': 'success',
                        'msg': "Vous êtes bien inscrit sur liste d'attente de cette séance !"
                    })
                } else {
                    this.$store.commit('setSnack', {
                        'type': 'success',
                        'msg': "Vous êtes bien inscrit à cette séance !"
                    })
                }

                let i = this.value.meetings.findIndex(m => m.id == meeting_id)
                if (i >= 0) {
                    Object.assign(this.value.meetings[i], response.data)
                }
                await this.getUserSubscribitions()
            } catch (err) {
                if (err.response?.status !== 403) {
                    this.$store.dispatch('setErrors', err.response?.data)
                }
            } finally {
                // Reset loading state for this specific meeting
                this.$set(this.loadingStates[meeting_id], 'subscribe', false)
            }
        },

        async unsubscribeMeeting(meeting_id, showNotification = true, forced = false) {
            // Initialize loading state for this meeting if it doesn't exist
            if (!this.loadingStates[meeting_id]) {
                this.$set(this.loadingStates, meeting_id, {})
            }
            // Set unsubscribe loading state for this specific meeting
            this.$set(this.loadingStates[meeting_id], 'unsubscribe', true)

            try {
                const response = await this.$store.dispatch('meetingUnsubscribeRequest', {
                    meeting_id: meeting_id,
                    user_id: this.$store.getters.getProfile.id,
                    forced: forced
                })
                
                if (showNotification) {
                    if (response.status === 202) {
                        this.$store.commit('setSnack', {
                            'type': 'success',
                            'msg': "Vous n'êtes plus sur la liste d'attente de cette séance"
                        })
                    } else {
                        this.$store.commit('setSnack', {
                            'type': 'success',
                            'msg': "Votre annulation de participation à la séance est prise en compte !"
                        })
                    }
                }

                let i = this.value.meetings.findIndex(m => m.id == meeting_id)
                await this.getUserSubscribitions()
                if (i >= 0) {
                    Object.assign(this.value.meetings[i], response.data)
                }
            } catch (err) {
                if (err.response?.status !== 403) {
                    this.$store.dispatch('setErrors', err.response?.data)
                }
            } finally {
                // Reset loading state for this specific meeting
                this.$set(this.loadingStates[meeting_id], 'unsubscribe', false)
            }
        },
        filterSubscribers(subscribers, status) {
            return subscribers.filter((s) => {
                return s.pivot.status == status
            })
        },
        fetchPartnerLogo() {
            let url = `${this.apiUrl}/storage/${this.value.partner.logo.path}`;
            this.logo_path = url
        },
        isValidatedSubscriber(meeting) {
            if (this.userSubscribitions.length == 0)
                return false
            return this.userSubscribitions.findIndex(sub => sub.id == meeting.id && sub.pivot.status == 'validated') > -1 
        },
        isWaitingSubscriber(meeting) {
            if (this.userSubscribitions.length == 0)
                return false
            return this.userSubscribitions.findIndex(sub => sub.id == meeting.id && sub.pivot.status == 'waiting') > -1 
        },
        saveAttendance(pivot) {
            this.attendanceLoading = true
            let queries = {
                meeting_id: pivot.meeting_id, 
                user_id: pivot.user_id,
                datas: pivot,
            }
            return this.$store.dispatch('meetingAttendanceRequest', queries).then(() => {
                this.$refs['attendanceForm'+pivot.id].cancel()
                this.attendanceLoading = false
            }).catch(() => {
                this.attendanceLoading = false
            });
        },
        urlify(text) {
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, (url) =>'<a href="' + url + '" target="_blank">' + url + '</a>')
                        // .replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2')
        },
        fetchMeetingsSubscribers() {
                this.meetingsLoading = true
                let search = {'workshop_id': this.value.id}
                if (! this.isThePro)
                    search.dates = [this.$moment(), this.$moment().add(999, 'years')]
                if (this.isThePro)
                    search.is_archived = false

                let queries = {
                    with: [],
                    search: JSON.stringify(search),
                    page: this.options.page,
                    sort: this.$route.query.sort ? this.$route.query.sort : 'start',
                    direction: this.options.sortDesc[0] ? 'desc' : 'asc',
                    per_page: this.options.itemsPerPage,
                }
                if(this.$store.getters.getProfile.id) { 
                    this.isThePro ? queries.with.push('subscribers') : queries.with.push('meeting_users')
                }
                this.$store.dispatch('meetingsRequest', queries)
                    .then(result => {
                        this.value.meetings = result.data
                        this.total = result.meta.total
                    })
                    .catch((err) => {
                        if (err.response.status != 403 && err.response.status != 401)
                            this.$store.dispatch('setErrors', err.response.data)
                    })
                    .finally(() => {
                        this.meetingsLoading = false
                    })
        },
        getSupport(type, sequence, meetingId = null) {
            // Check workshop type to set support type needed
            // Support type is 'classique' for all workshops except Aja
            let supportType = 'classique'
            if (this.value.is_aja)
                supportType = 'aja'

            const queries = {
                per_page: -1,
                search: JSON.stringify({'sequence': sequence, 'support_type': supportType}),
                with: ['pro_attachment', 'user_attachment', 'guide_attachment'],            
            }
                return this.$store.dispatch('supportsRequest', queries).then((data) => {           
                    let results = data.data
                    if(!results[0][type+'_attachment']) {
                        return this.$store.commit('setSnack', {'type': 'error', 'msg': 'Auncun support trouvé'}); 
                    }
                    if (results.length && type == "user")
                        this.downloadAttachment(results[0][type+'_attachment'], meetingId)
                    else    
                        this.previewAttachment(type+'_attachment', results[0][type+'_attachment'], meetingId)
                })
                .catch((err) => {
                    if (err.response?.status != 403)
                        this.$store.dispatch('setErrors', "Une erreur est survenue lors de la récupération des supports. Veuillez réessayer plus tard.")
                });
        },
        downloadAttachment(attachment, meetingId = null) {
            const params = { id: attachment.id };
            if (meetingId) {
                params.meeting_id = meetingId;
            }
            
            return this.$store.dispatch('attachmentDownloadRequest', params)
                .then((data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', attachment.name);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((err) => {
                    if (err.response?.status == 403) {
                        this.$store.commit('setSnack', {'type': 'error', 'msg': 'Action non autorisée. Vos droits d\'accès aux supports ont peut-être changé.'});
                        this.$store.dispatch('profileRequest');
                    } else {
                        this.$store.commit('setSnack', {'type': 'error', 'msg': 'Erreur lors du téléchargement du support.'});
                    }
                });
        },
        async previewAttachment(type, attachment, meetingId = null) {
            const params = { id: attachment.id };
            if (meetingId) {
                params.meeting_id = meetingId;
            }

            // Get meeting end time for access control
            let meetingEnd = null;
            if (meetingId) {
                const meeting = (this.value.meetings || []).find(m => m.id === meetingId);
                if (meeting) {
                    // API dates are Paris time: converted to ISO UTC for the injected script
                    meetingEnd = parisDateToIso(meeting.end);
                }
            }

            const zipData = await this.$store.dispatch('attachmentDownloadRequest', params);
            // Load the zip file from a blob
            const zipRoot = await JSZip.loadAsync(zipData);
            // Get the HTML file from the zip
            const htmlFile = zipRoot.file("index.html");
            // Get the contents of the HTML file
            let htmlContent = await htmlFile.async("string");
            // Create a base URL that points to the blob object
            const baseUrl = process.env.VUE_APP_API_URL + `/api/supports/${attachment.attachable_id}/${type}/proxy/`;
            // Inject base tag in the head with baseUrl as href attribute
            var parser = new DOMParser();
            var doc = parser.parseFromString(htmlContent, 'text/html');
            var head = doc.getElementsByTagName('head')[0];
            var baseElement = document.createElement('base');
            baseElement.setAttribute('href', baseUrl)
            head.appendChild(baseElement);

            // Inject access control script (timer 2h10, 2h30 for ONCO'MMENCE + meeting end + 15min)
            const accessControlScript = generateAccessControlScript({
                apiUrl: process.env.VUE_APP_API_URL,
                supportId: attachment.attachable_id,
                type: type,
                meetingId: meetingId,
                meetingEnd: meetingEnd,
                maxDurationMinutes: this.value.workshop_type === 'oncommence' ? ONCOMMENCE_ACCESS_TIMER_MINUTES : ACCESS_TIMER_MINUTES
            });
            const scriptElement = doc.createElement('script');
            scriptElement.textContent = accessControlScript;
            doc.body.appendChild(scriptElement);

            // Open the preview content in a new browser tab
            const previewContent = doc.documentElement.outerHTML;
            const previewWindow = window.open();
            previewWindow.document.write(previewContent);
            previewWindow.document.close();
        },
        async getUserSubscribitions() {
            try {
                const { data } = await this.$store.dispatch('getUserSubscribitionsRequest', {
                    user_id: this.$store.getters.getProfile.id,
                })
                this.userSubscribitions = data
            } catch (err) {
                this.userSubscribitions = []
                if (err.response?.status !== 403) {
                    this.$store.dispatch('setErrors', err.response?.data)
                }
            }
        },
        async handleTakePlace(meeting) {
            try {
                // For oncommence meetings, unsubscribe from all other future oncommence subscriptions (#F_SEA_31)
                if (meeting.workshop?.workshop_type === 'oncommence' || this.value?.workshop_type === 'oncommence') {
                    await this.unsubscribeFromOtherFutureOncommenceMeetings(meeting);
                } else if (await this.isSubscribedToOtherMeetingsOfSameSequence(meeting)) {
                    await this.unsubscribeFromOtherMeetingsOfSameSequence(meeting);
                }

                // Silent unsubscribe the meeting if it's already subscribed
                if (this.isWaitingSubscriber(meeting)) {
                    await this.unsubscribeMeeting(meeting.id, false);
                }

                // Then subscribe to this meeting
                await this.subscribeMeeting(meeting.id);
            } catch (err) {
                if (err.response?.status !== 403) {
                    this.$store.dispatch('setErrors', err.response?.data);
                }
            }
        },
        isSubscribedToOtherMeetingsOfSameSequence(meeting) {
            return this.userSubscribitions.some(
                sub => sub.sequence == meeting.sequence
                && sub.id != meeting.id
                && this.$moment(sub.start).isAfter(this.$moment())
            )
        },
        unsubscribeFromOtherMeetingsOfSameSequence(meeting) {
            const sequence = meeting.sequence
            // Get all meetings of the same sequence that are not the current meeting and that are in the future
            const otherMeetings = this.userSubscribitions.filter(sub =>
                sub.sequence == sequence
                && sub.id != meeting.id
                && this.$moment(sub.start).isAfter(this.$moment())
            )
            // Unsubscribe from other meetings with forced=true to avoid penalizing the user
            // (this is an automatic unsubscription when taking a place from waitlist)
            const promises = otherMeetings.map(meeting => {
                return this.unsubscribeMeeting(meeting.id, false, true)
            })
            return Promise.all(promises)
        },
        unsubscribeFromOtherFutureOncommenceMeetings(meeting) {
            // #F_SEA_31: when promoting from L.A. on an oncommence meeting, the user can only have
            // one active oncommence subscription. Auto-unsubscribe from all other future oncommence
            // subscriptions (validated or waiting) to free the constraint.
            const otherMeetings = this.userSubscribitions.filter(sub => {
                const isOncommence = sub.workshop?.workshop_type === 'oncommence'
                return isOncommence
                    && sub.id != meeting.id
                    && this.$moment(sub.start).isAfter(this.$moment())
            })
            const promises = otherMeetings.map(m => this.unsubscribeMeeting(m.id, false, true))
            return Promise.all(promises)
        },
        validatedSubscriberIds(meeting) {
            return (meeting.subscribers || [])
                .filter(s => s.pivot?.status === 'validated')
                .map(s => s.id)
        },
        messageAllSubscribers(meeting) {
            const ids = this.validatedSubscriberIds(meeting)
            if (!ids.length) return
            this.$router.push({
                name: 'Messagerie',
                query: { recipients: ids.join(','), subject: `Séance du ${this.$moment(meeting.start).format('DD/MM/YYYY')} — ${this.value.name}` },
            })
        },
        async exportMeetingSubscribers(meeting) {
            if (!this.loadingStates[meeting.id]) {
                this.$set(this.loadingStates, meeting.id, {});
            }
            this.$set(this.loadingStates[meeting.id], 'export', true);

            this.$store.dispatch('meetingExportSubscribersRequest', {
                meeting_id: meeting.id
            }).then((response) => {
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(new Blob([response]))
                link.setAttribute('download', 'participants.xlsx')
                document.body.appendChild(link)
                link.click()
                link.remove()
            }).catch((err) => {
                this.$store.dispatch('setErrors', err.response?.data)
            }).finally(() => {
                this.$set(this.loadingStates[meeting.id], 'export', false);
            })
        },
        isMeetingWithin48Hours(meeting) {
            const now = this.$moment();
            const meetingStart = this.$moment(meeting.start);
            const hoursUntilMeeting = meetingStart.diff(now, 'hours');
            return hoursUntilMeeting >= 0 && hoursUntilMeeting <= 48;
        },
        isMeetingWithin36Hours(meeting) {
            const now = this.$moment();
            const meetingStart = this.$moment(meeting.start);
            const hoursUntilMeeting = meetingStart.diff(now, 'hours');
            return hoursUntilMeeting >= 0 && hoursUntilMeeting < 36;
        },
        showLateUnsubscribeWarning(meeting) {
            // No late warning for ONCO'MMENCE workshops
            if (this.value?.workshop_type === 'oncommence') {
                return false;
            }
            return this.isMeetingWithin36Hours(meeting);
        },
        getUnsubscribeWarning(meeting) {
            // No penalty warning for ONCO'MMENCE workshops
            if (this.value?.workshop_type === 'oncommence') {
                return '';
            }
            if (this.isMeetingWithin36Hours(meeting)) {
                return `<strong>Attention :</strong> Cette séance commence dans moins de 36 heures.<br><br>
                    Si vous vous désinscrivez maintenant, <strong>cette séance sera comptabilisée</strong>
                    dans votre quota de séances et comptera comme une annulation tardive.`;
            }
            return '';
        },
        getParticipateSubtext(meeting) {
            if (this.isMeetingWithin48Hours(meeting)) {
                const iconColor = this.isThemeAja ? '#4E983C' : '#f7921d';
                const buttonStyle = `display: inline-flex; align-items: center; justify-content: center; border: 1px solid ${iconColor}; 
                border-radius: 4px; padding: 4px 16px; vertical-align: middle;`;
                return `Vous trouverez le livret ET le lien VISIO ou l'adresse de votre séance sous 
                    BONJOUR/ MON COMPTE/MES SEANCES/ <span style="${buttonStyle}"><i class="v-icon notranslate 
                        material-icons" style="color: ${iconColor}; font-size: 18px;">
                        get_app</i></span> sur la séance concernée`;
            }
            return '';
        },
        canAccessSupport(meeting) {
            // Si ce n'est pas un pro, utiliser la logique existante
            if (!this.isThePro) {
                return true;
            }

            // CORRECTION: Utiliser l'utilisateur connecté au lieu du propriétaire du workshop
            const currentUser = this.$store.getters.getProfile;

            // If the user profile is not available, return false
            if (!currentUser || !currentUser.current_pro_status) {
                return false;
            }

            const currentProStatus = currentUser.current_pro_status;
            const now = this.$moment();
            const meetingStart = this.$moment(meeting.start);
            const timeUntilMeeting = meetingStart.diff(now, 'minutes');

            // Oncommence : access 7 days before the start of the meeting,
            // regardless of pro status
            if (this.value.workshop_type == 'oncommence') {
                return timeUntilMeeting <= 7 * 24 * 60;
            }

            // CORRECTION: Utiliser le statut de l'utilisateur connecté
            if (currentUser.is_pro_status_blocked) {
                // Pro bloqué : au moins le guide est accessible 24h avant
                return timeUntilMeeting <= 24 * 60;
            }

            switch (currentProStatus.type) {
                case 'licence':
                    // Licence : access without time limit
                    return true;
                case 'novice':
                    // Novice : access 72h before the start of the meeting
                    return timeUntilMeeting <= 72 * 60;
                case 'basic':
                default:
                    // Basic : au moins le guide est accessible 24h avant
                    return timeUntilMeeting <= 24 * 60;
            }
        },
        /**
         * Vérifie si un type de support spécifique est accessible pour un meeting
         *
         * Règles par statut pro :
         * - Licence : accès illimité à tous les supports
         * - Novice : 72h avant pour tous les supports (guide, diapo, livret)
         * - Basic (classique) :
         *   - Guide : 24h avant
         *   - Livret : 24h avant
         *   - Diapo : 15 min avant
         *
         * @param {Object} meeting - La séance
         * @param {string} type - Type de support: 'guide', 'pro' (diapo), 'user' (livret)
         * @returns {boolean}
         */
        canAccessSupportByType(meeting, type) {
            // Si ce n'est pas un pro, accès autorisé
            if (!this.isThePro) {
                return true;
            }

            const currentUser = this.$store.getters.getProfile;

            if (!currentUser || !currentUser.current_pro_status) {
                return false;
            }

            const currentProStatus = currentUser.current_pro_status;
            const now = this.$moment();
            const meetingStart = this.$moment(meeting.start);
            const timeUntilMeeting = meetingStart.diff(now, 'minutes');

            // Oncommence : accès 7 jours avant, pour tous les supports
            if (this.value.workshop_type == 'oncommence') {
                return timeUntilMeeting <= 7 * 24 * 60;
            }

            // Déterminer le statut effectif (si bloqué, traité comme basic)
            const effectiveStatus = currentUser.is_pro_status_blocked ? 'basic' : currentProStatus.type;

            // Calculer la limite de temps selon le statut et le type de support
            const timeLimit = this.getTimeLimitForSupportType(effectiveStatus, type);

            // Si pas de limite (licence), accès autorisé
            if (timeLimit === null) {
                return true;
            }

            return timeUntilMeeting <= timeLimit;
        },
        /**
         * Retourne la limite de temps en minutes selon le statut pro et le type de support
         *
         * @param {string} proStatus - 'licence', 'novice', ou 'basic'
         * @param {string} supportType - 'guide', 'pro' (diapo), 'user' (livret)
         * @returns {number|null} Limite en minutes avant la séance, ou null si illimité
         */
        getTimeLimitForSupportType(proStatus, supportType) {
            switch (proStatus) {
                case 'licence':
                    return null; // Illimité

                case 'novice':
                    return 72 * 60; // 72h = 4320 minutes pour tous les supports

                case 'basic':
                default:
                    // Basic : règles différenciées par type de support
                    if (supportType === 'pro') {
                        // Diapo : 15 minutes avant
                        return 15;
                    }
                    // Guide et livret : 24h avant
                    return 24 * 60;
            }
        },
    }
}
</script>
